import BlockTypes from '../../../types/BlockTypes';

function isInEmbedPlaceholder(value) {
  var startBlock = value.startBlock,
      endBlock = value.endBlock,
      selection = value.selection;
  return selection.isSet && startBlock.type === BlockTypes.EMBED_PLACEHOLDER && endBlock.type === BlockTypes.EMBED_PLACEHOLDER;
}

export default isInEmbedPlaceholder;